/**
 * 随机昵称词库：褒义三字形容词 ×100，褒义 2～3 字名词 ×100。
 * 仅用于本地组合展示昵称，不提交词库到服务端。
 */

/** 三字形容词（多叠词/口语褒义，用于轻松昵称感） */
export const ADJECTIVES_3: readonly string[] = [
  "美滋滋",
  "乐陶陶",
  "喜洋洋",
  "笑哈哈",
  "暖洋洋",
  "香喷喷",
  "甜丝丝",
  "红艳艳",
  "金灿灿",
  "银闪闪",
  "清亮亮",
  "蓝盈盈",
  "白花花",
  "沉甸甸",
  "轻盈盈",
  "软绵绵",
  "直挺挺",
  "气昂昂",
  "光闪闪",
  "响当当",
  "顶呱呱",
  "棒棒哒",
  "呱呱叫",
  "甜滋滋",
  "辣乎乎",
  "鲜灵灵",
  "水汪汪",
  "胖乎乎",
  "文彬彬",
  "稳当当",
  "真切切",
  "实笃笃",
  "笃悠悠",
  "清朗朗",
  "明晃晃",
  "活蹦蹦",
  "齐刷刷",
  "齐崭崭",
  "高朗朗",
  "喜滋滋",
  "兴冲冲",
  "笑嘻嘻",
  "乐融融",
  "和美美",
  "安妥妥",
  "平展展",
  "顺当当",
  "顺溜溜",
  "光灿灿",
  "明闪闪",
  "金晃晃",
  "玉润润",
  "珠亮亮",
  "银晃晃",
  "风细细",
  "日融融",
  "月皎皎",
  "星点点",
  "光熠熠",
  "水粼粼",
  "天蓝蓝",
  "海蓝蓝",
  "山青青",
  "花艳艳",
  "叶葱葱",
  "果累累",
  "米香香",
  "汤浓浓",
  "茶清清",
  "书满满",
  "路宽宽",
  "车快快",
  "步轻轻",
  "心暖暖",
  "意拳拳",
  "情切切",
  "义凛凛",
  "志昂昂",
  "神奕奕",
  "乐呵呵",
  "面善善",
  "语柔柔",
  "言恳恳",
  "行端端",
  "品方方",
  "学勤勤",
  "工巧巧",
  "艺湛湛",
  "才思思",
  "智灵灵",
  "思敏敏",
  "行笃笃",
  "信满满",
  "爱满满",
  "福多多",
  "运旺旺",
  "财滚滚",
  "路通通",
  "业腾腾",
  "圆满满",
] as const;

/** 2～3 字名词（可叠用组合，偏可爱/自然/吉祥） */
export const NOUNS_2_3: readonly string[] = [
  "包子",
  "小草",
  "天才",
  "月亮",
  "星星",
  "晨曦",
  "彩虹",
  "小鹿",
  "白兔",
  "锦鲤",
  "汤圆",
  "馒头",
  "豆浆",
  "熊猫",
  "海豚",
  "向日葵",
  "蒲公英",
  "四叶草",
  "珍珠",
  "琥珀",
  "贝壳",
  "浪花",
  "云朵",
  "晚风",
  "清泉",
  "小溪",
  "山岚",
  "松涛",
  "竹影",
  "雪芽",
  "新叶",
  "花苞",
  "金穗",
  "银铃",
  "玉琮",
  "玛瑙",
  "珊瑚",
  "石英",
  "小太阳",
  "小月亮",
  "小福气",
  "小元宝",
  "小福袋",
  "小确幸",
  "数学迷",
  "小书虫",
  "小达人",
  "小机灵",
  "小秀才",
  "小才子",
  "小才女",
  "小财迷",
  "小财主",
  "小掌柜",
  "小海星",
  "小海贝",
  "小海鸥",
  "小帆船",
  "小灯塔",
  "小港口",
  "小丘陵",
  "小山谷",
  "小高原",
  "小冰川",
  "小晴天",
  "小阴天",
  "小雷雨",
  "小闪电",
  "小彩虹",
  "小霓虹",
  "小晨星",
  "小暮星",
  "小流萤",
  "小萤火",
  "小灯笼",
  "小烛火",
  "小夜灯",
  "小夜曲",
  "小钢琴",
  "小吉他",
  "小笛子",
  "小琵琶",
  "小古筝",
  "小象棋",
  "小围棋",
  "小书童",
  "小墨香",
  "小砚台",
  "小湖蓝",
  "小湖青",
  "小湖心",
  "金元宝",
  "银元宝",
  "小云朵",
  "小流星",
  "小彗星",
  "小行星",
  "小银河",
  "小春燕",
  "小秋鸿",
] as const;

if (process.env.NODE_ENV === "development") {
  const assertLength = (
    name: string,
    arr: readonly string[],
    expected: number,
    eachLen: (s: string) => boolean
  ) => {
    if (arr.length !== expected) {
      // eslint-disable-next-line no-console
      console.error(`[nicknameWordBank] ${name} 长度应为 ${expected}，实际 ${arr.length}`);
    }
    for (const s of arr) {
      if (!eachLen(s)) {
        // eslint-disable-next-line no-console
        console.error(`[nicknameWordBank] ${name} 词 "${s}" 长度不符合约定`);
      }
    }
  };
  assertLength("ADJECTIVES_3", ADJECTIVES_3, 100, (s) => s.length === 3);
  assertLength("NOUNS_2_3", NOUNS_2_3, 100, (s) => s.length >= 2 && s.length <= 3);
}
